const colourConfigs = {
  sidebar: {
    bg: "#2c3e50", // Deep blue-grey for sophistication
    colour: "#ecf0f1",
    hoverBg: "#34495e",
    activeBg: "#1a252f"
  },
  topbar: {
    bg: "#ffffff",
    colour: "#2c3e50"
  },
  mainBg: "#f8f9fa", // Clean off-white background
  accent: {
    primary: "#e74c3c", // Warm red for CTAs
    secondary: "#3498db", // Trustworthy blue
    tertiary: "#95a5a6" // Soft grey for subtle elements
  },
  text: {
    primary: "#2c3e50",
    secondary: "#7f8c8d",
    light: "#95a5a6"
  }
};

export default colourConfigs;